function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "video-recorder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 7.44313C18.3334 6.93829 18.3334 6.68586 18.2336 6.56898C18.147 6.46756 18.017 6.41373 17.8841 6.4242C17.7308 6.43626 17.5523 6.61475 17.1953 6.97173L14.1667 10.0003L17.1953 13.0289C17.5523 13.3859 17.7308 13.5644 17.8841 13.5765C18.017 13.5869 18.147 13.5331 18.2336 13.4317C18.3334 13.3148 18.3334 13.0624 18.3334 12.5575V7.44313Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 8.16699C1.66675 6.76686 1.66675 6.0668 1.93923 5.53202C2.17892 5.06161 2.56137 4.67916 3.03177 4.43948C3.56655 4.16699 4.26662 4.16699 5.66675 4.16699H10.1667C11.5669 4.16699 12.2669 4.16699 12.8017 4.43948C13.2721 4.67916 13.6546 5.06161 13.8943 5.53202C14.1667 6.0668 14.1667 6.76686 14.1667 8.16699V11.8337C14.1667 13.2338 14.1667 13.9339 13.8943 14.4686C13.6546 14.939 13.2721 15.3215 12.8017 15.5612C12.2669 15.8337 11.5669 15.8337 10.1667 15.8337H5.66675C4.26662 15.8337 3.56655 15.8337 3.03177 15.5612C2.56137 15.3215 2.17892 14.939 1.93923 14.4686C1.66675 13.9339 1.66675 13.2338 1.66675 11.8337V8.16699Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e82fcf01c4ca992581c954d0527163d6.svg";
export { ForwardRef as ReactComponent };